import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Search24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.94302 12.7111C3.6635 9.70043 5.0669 6.22253 8.0776 4.94302C11.0883 3.6635 14.5662 5.0669 15.8457 8.0776C16.8113 10.3495 16.249 12.8875 14.6212 14.5461C14.6079 14.5576 14.595 14.5696 14.5823 14.5823C14.5696 14.595 14.5574 14.6081 14.5458 14.6215C14.0313 15.1271 13.4152 15.5465 12.7111 15.8457C9.70043 17.1252 6.22253 15.7218 4.94302 12.7111ZM15.0776 16.1166C14.5475 16.5501 13.9478 16.9166 13.2858 17.1979C9.52831 18.7948 5.18772 17.0433 3.59083 13.2858C1.99394 9.52831 3.74544 5.18772 7.50293 3.59083C11.2604 1.99394 15.601 3.74544 17.1979 7.50293C18.3099 10.1194 17.7982 13.0187 16.1162 15.0774L20.7849 19.7467C21.0717 20.0336 21.0717 20.4987 20.7848 20.7856C20.4979 21.0725 20.0328 21.0724 19.7459 20.7855L15.0776 16.1166Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
